const CATCHALL_ROUTE_NAME = 'slug'

interface ResolvedRoute { matched: unknown[], name?: string | symbol | null }

// Skip catch-all routes so unknown paths load from the server. This allows redirects instead of client-side 404s
export function isNavigableInternalHref(href: string | null | undefined, resolve: (to: string) => ResolvedRoute, catchallName: string = CATCHALL_ROUTE_NAME): href is string {
  if (!href || !href.startsWith('/')) {
    return false
  }
  const resolved = resolve(href)
  return resolved.matched.length > 0 && resolved.name !== catchallName
}

function isModifiedClick(event: MouseEvent): boolean {
  return event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey
}

export function useContentInternalLinks(containerRef: Ref<HTMLElement | null>) {
  const router = useRouter()
  const resolve = (to: string) => router.resolve(to) as ResolvedRoute

  function activate(target: EventTarget | null, event: Event) {
    const link = (target as HTMLElement | null)?.closest('a')
    const href = link?.getAttribute('href')
    if (!isNavigableInternalHref(href, resolve)) {
      return
    }
    event.preventDefault()
    navigateTo(href)
  }

  function handleClick(event: MouseEvent) {
    if (isModifiedClick(event)) {
      return
    }
    activate(event.target, event)
  }

  function handleKeydown(event: KeyboardEvent) {
    if (event.key !== 'Enter') {
      return
    }
    activate(event.target, event)
  }

  watchEffect((onCleanup) => {
    const container = containerRef.value
    if (!container) {
      return
    }
    container.addEventListener('click', handleClick)
    container.addEventListener('keydown', handleKeydown)
    onCleanup(() => {
      container.removeEventListener('click', handleClick)
      container.removeEventListener('keydown', handleKeydown)
    })
  })
}
